import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import PropTypes from "prop-types";

Navbar.propTypes = {
  scrollToSection: PropTypes.func.isRequired,
  activeSection: PropTypes.string.isRequired,
};

const navigation = [
  { name: "Home", section: "home" },
  { name: "About", section: "about2" },
  { name: "Services", section: "services" },
  { name: "Portfolio", section: "portfolio" },
  { name: "Achievement", section: "achievement" },
  { name: "Contact Us", section: "contact" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Navbar({ scrollToSection, activeSection }) {
  return (
    <Disclosure as="nav" className="bg-black sticky top-0 z-50" role="navigation" aria-label="Main navigation">
      {({ open }) => (
        <>
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="flex h-16 items-center justify-between">
              {/* Logo */}
              <div className="flex items-center gap-3">
                <img
                  src="/images/Uniway_Logo.png"
                  alt="UniwayStart Logo"
                  className="h-10 w-auto"
                />
                <h1 className="text-white font-bold text-2xl">
                  Uniwaystart
                </h1>
              </div>

              {/* Desktop Navigation */}
              <div className="hidden sm:flex sm:space-x-10 ml-auto">
                {navigation.map((item) => (
                  <a
                    key={item.section}
                    href={`#${item.section}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(item.section);
                    }}
                    className={classNames(
                      activeSection === item.section
                        ? "text-blue-500"
                        : "text-white hover:text-gray-300",
                      "font-medium transition-colors duration-200"
                    )}
                  >
                    {item.name}
                  </a>
                ))}
              </div>

              {/* Mobile Menu Button */}
              <div className="sm:hidden">
                <DisclosureButton className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                  <span className="sr-only">Toggle menu</span>
                </DisclosureButton>
              </div>
            </div>
          </div>

          {/* Mobile Navigation Panel */}
          <DisclosurePanel className="sm:hidden bg-gray-800">
            <div className="space-y-1 px-2 py-3">
              {navigation.map((item) => (
                <DisclosureButton
                  key={item.section}
                  as="a"
                  href={`#${item.section}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(item.section);
                  }}
                  aria-current={activeSection === item.section ? "page" : undefined}
                  className={classNames(
                    activeSection === item.section
                      ? "bg-gray-900 text-white"
                      : "text-gray-300 hover:bg-gray-700 hover:text-white",
                    "block rounded-md px-3 py-2 text-base font-medium"
                  )}
                >
                  {item.name}
                </DisclosureButton>
              ))}
            </div>
          </DisclosurePanel>
        </>
      )}
    </Disclosure>
  );
}
